import {
    loginReducer,
    forgotPasswordReducer,
    resetPasswordReducer,
    creatUserReducer,
    confirmEmailReducer,
    resendActivationEmailReducer,
    confirmAccountPhoneReducer,
    getOtpForVendorPhoneReducer,
    getUrlReducer,
    getStoreCatsReducer,
    uploadStoreLogoReducer
} from "../reducers/onboarding/outbound.reducer"

import {
    createStoreProductReducer,
    updateStoreProductReducer,
    getProductMetaDataReducer,
    getImageGalleryReducer,
    getProductListReducer,
    toggleProductReducer,
    getAProductReducer,
    updateProductImageReducer,
    getStoreOrderReducer,
    getStoreOrderDetailsReducer,
    createStorePayoutReducer,
    getStorePayoutAccReducer,
    getStoreDetailsReducer,
    updateStoreDetailsReducer,
    getDashbardTopDataReducer,
    getDashbardMiddleDataReducer,
    getDashbardBottompDataReducer,

    createPayoutInfoTokenReducer,
    getPayoutPendingLinkReducer,
    getStorePaymentsHistoryReducer,

    changeOrderStatusReducer
} from "../reducers/inapp/inapp.reducer"



export const inAppReducers = {
    createStoreProductReducer,
    updateStoreProductReducer,
    getProductMetaDataReducer,
    getImageGalleryReducer,
    getProductListReducer,
    toggleProductReducer,
    getAProductReducer,
    updateProductImageReducer,
    getStoreOrderReducer,
    getStoreOrderDetailsReducer,
    createStorePayoutReducer,
    getStorePayoutAccReducer,
    getStoreDetailsReducer,
    updateStoreDetailsReducer,
    getDashbardTopDataReducer,
    getDashbardMiddleDataReducer,
    getDashbardBottompDataReducer,

    createPayoutInfoTokenReducer,
    getPayoutPendingLinkReducer,
    getStorePaymentsHistoryReducer,

    changeOrderStatusReducer
}



export const outboundReducers = {
    loginReducer,
    forgotPasswordReducer,
    resetPasswordReducer,
    creatUserReducer,
    confirmEmailReducer,
    resendActivationEmailReducer,
    confirmAccountPhoneReducer,
    getOtpForVendorPhoneReducer,
    getUrlReducer,
    getStoreCatsReducer,
    uploadStoreLogoReducer
}


